import script from "./CompetitionView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionView.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionView.vue?vue&type=style&index=0&id=77a6e5dd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a6e5dd"]])

export default __exports__